import { Box, Divider } from "@mui/material";
import React from "react";
import { PastProjectHeaderContent } from "./PastProjectHeaderContent";
import { PastProjectHeaderSummary } from "./PastProjectHeaderSummary";

export const PastProjectHeader: React.FC = () => {
  return (
    <Box display="flex" columnGap={12} height={250}>
      <PastProjectHeaderContent />
      <Divider orientation="vertical" flexItem />
      <PastProjectHeaderSummary />
    </Box>
  );
};
